export default `vec2 wrap ( vec2 x, vec2 a, vec2 s ) {
  x -= s;
  return ( x - a * floor( x / a ) ) + s;
}

void TransA ( inout vec3 z, inout float DF, float a, float b ) {
  float iR = 1.0 / dot( z, z );
  z *= -iR;
  z.x = -b - z.x; 
  z.y =  a + z.y;
  DF *= iR; 
}

float de( vec3 z ) {
  float t = 0.0;
  float KleinR = 1.5 + 0.39;
  float KleinI = ( 0.55 * 2.0 - 1.0 );
  vec2 box_size = vec2( -0.40445, 0.34 ) * 2.0;
  vec3 lz = z + vec3( 1.0 ), llz = z + vec3( -1.0 );
  float d = 0.0; float d2 = 0.0;
  float DE = 1e12;
  float DF = 1.0;
  float a = KleinR;
  float b = KleinI;
  float f = sign( b ) * 0.45;
  for ( int i = 0; i < 80 ; i++ ) {
    z.x += b / a * z.y;
    z.xz = wrap( z.xz, box_size * 2.0, -box_size );
    z.x -= b / a * z.y;
    if ( z.y >= a * 0.5 + f * ( 2.0 * a - 1.95 ) / 4.0 * sign( z.x + b * 0.5 ) * 
     ( 1.0 - exp( -( 7.2 - ( 1.95 - a ) * 15.0 )* abs(z.x + b * 0.5 ) ) ) ) {
      z = vec3( -b, a, 0.0 ) - z;
    } 
    TransA(z, DF, a, b); 
    if ( dot( z - llz, z - llz ) < 1e-5 ) {
      break;
    } 
    llz = lz; lz = z; 
  }
  float y =  min( z.y, a - z.y );
  DE = min( DE, min( y, 0.3 ) / max( DF, 2.0 ) );
  return DE;
}`